export const NO_PHONE_NUMBER = '+123456';
